import {dropdownWithoutSizeRegX, dropdownWithSizeRegX, inputRegX} from '../../_common/regexe'
import pipe from 'ramda/es/pipe'
import defaultTo from 'ramda/es/defaultTo'


const log = x => { console.warn(x); return x }

export const countTasksWithin = answer => {
    const options   = answer.question().answerOptions()
    const saveMatch = pipe( regX=>options.match(regX), defaultTo([]) )
    const getCount  = (sum, regX) => sum + saveMatch(regX).length

    return [dropdownWithSizeRegX, dropdownWithoutSizeRegX, inputRegX].reduce( getCount, 0 )
}